import React, { useState } from "react";
import "./modal.scss";
const EmailModal = ({ isOpen, onClose, clientEmail, onSend }) => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSend({ to: clientEmail, subject, message });
    onClose(); // close modal after sending
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-content">
          <h2 className="modal-title">Envoyer un Email</h2>
          <form onSubmit={handleSubmit}>
            <div className="modal-form-group">
              <label className="modal-label">À :</label>
              <input
                type="email"
                value={clientEmail}
                disabled
                className="modal-input"
              />
            </div>
            <div className="modal-form-group">
              <label className="modal-label">Sujet :</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="modal-input"
                required
              />
            </div>
            <div className="modal-form-group">
              <label className="modal-label">Message :</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="modal-input"
                rows="5"
                required
              />
            </div>
            <div className="modal-actions">
              <button
                type="button"
                onClick={onClose}
                className="modal-btn modal-cancel"
              >
                Annuler
              </button>
              <button type="submit" className="modal-btn modal-send">
                Envoyer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailModal;
